angular.module('v3sWbtPlayerApp').directive('v3sLabelWithStatusDirective', ['v3sWbtDataService', function (v3sWbtDataService) {
    return {
        restrict: 'EA',
        templateUrl: "app/js/navigation/labelWithStatus/labelWithStatus.tpl.html",
        scope: {
            'item': '=',
            'container': '='
        },
        link: function (scope, element, attrs) {
            if (!scope.item) {
                return;
            }

            scope.cssClass = scope.item.type;

            if (!scope.item.isTrackable()) {
                scope.cssClass += " not-trackable";
            }

            if (!!scope.item.sco && !v3sWbtDataService.isScoStatusLoaded(scope.item.id)) {
                scope.cssClass += " no-data-loaded";
            }

        }
    }
}]);